import { createSelector } from 'reselect';
import { nullIfFirstArgNegative } from '@Utils';

const queryContainerState = (state) => state.get('queryletReducer');

export const nodesList = (state) => queryContainerState(state).nodesList;
export const favList = (state) => queryContainerState(state).favList;
export const hiddenList = (state) => queryContainerState(state).hiddenList;
export const properties = (state) => queryContainerState(state).properties;
export const forms = (state) => queryContainerState(state).forms;
export const historyItems = (state) => queryContainerState(state).historyItems;
export const indexedQuerylets = (state) => queryContainerState(state).indexedQuerylets;
export const indexedForms = (state) => queryContainerState(state).indexedForms;
export const importedQuery = (state) => queryContainerState(state).importedQuery;
export const searchSectionPanelState = (state) => queryContainerState(state).searchSectionPanelState;
export const searchSectionOpenedTab = createSelector(
  [searchSectionPanelState],
  nullIfFirstArgNegative((_searchSectionPanelState) => _searchSectionPanelState.openedTab)
);
export const searchSectionOpenedPanels = createSelector(
  [searchSectionPanelState],
  nullIfFirstArgNegative((_searchSectionPanelState) => _searchSectionPanelState.openedPanels)
);

export const searchSectionSearchValue = createSelector(
  [searchSectionPanelState],
  nullIfFirstArgNegative((_searchSectionPanelState) => _searchSectionPanelState.searchValue)
);
